export function KeyIcon({ className }: { className?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.00227 3C8.36864 1.2525 6.65318 0 4.63636 0C2.07864 0 0 2.0175 0 4.5C0 6.9825 2.07864 9 4.63636 9C6.65318 9 8.36864 7.7475 9.00227 6H12.3636V9H15.4545V6H17V3H9.00227ZM4.63636 6C3.78636 6 3.09091 5.325 3.09091 4.5C3.09091 3.675 3.78636 3 4.63636 3C5.48636 3 6.18182 3.675 6.18182 4.5C6.18182 5.325 5.48636 6 4.63636 6Z"
        fill="currentcolor"
      />
    </svg>
  );
}
